import { createContext, useContext } from "react";
import type { TenantMembership, Tenant } from "@/features/auth/use-tenant-context";

export interface TenantContextValue {
  memberships: TenantMembership[];
  tenants: Tenant[];
  activeTenant: Tenant | null;
  activeMembership: TenantMembership | null;
  isLoading: boolean;
  error: string | null;
  setActiveTenant: (tenantId: string) => void;
  profileName: string | null;
}

export const TenantContext = createContext<TenantContextValue | undefined>(undefined);

export function useTenantContext() {
  const context = useContext(TenantContext);
  if (!context) throw new Error("useTenantContext must be used inside TenantProvider");
  return context;
}
